<script lang="ts">
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let isOpen = false;
  export let serviceUrl = "";

  function close() {
    dispatch("close");
  }
</script>

{#if isOpen}
  <div class="fixed inset-0 z-50 flex flex-col bg-white animate-fade-in">
   <div class="sticky top-0 bg-[#1e3a8a] z-10 px-4 py-4 flex items-center">
      <!-- Left spacer, mirrors the close button's width to keep the title centered -->
      <div class="w-10 h-10"></div>

      <h2 class="flex-1 text-center font-bold text-lg text-white">Fina Loan</h2>

      <!-- <button
        type="button"
        on:click={close}
        class="flex items-center justify-center w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 text-white"
        aria-label="Close"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button> -->
    </div>
    <!-- <div class="sticky top-0 bg-white z-10 px-4 py-4 border-b border-gray-100 flex items-center justify-between">
      <h2 class="font-bold text-lg text-gray-900">Fina Loan</h2>

      <button
        type="button"
        on:click={close}
        class="flex items-center gap-2 text-gray-500 hover:text-gray-700"
        aria-label="Close"
      >
        <span class="text-sm font-medium">ປິດໜ້ານີ້</span>
        <span class="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      </button>
    </div> -->

    <div class="flex-1 relative bg-gray-50">
      {#if serviceUrl}
        <iframe
          src={serviceUrl}
          title="Fina Loan"
          class="absolute inset-0 w-full h-full border-0"
          allow="camera; microphone; geolocation"
        ></iframe>
      {:else}
        <div class="flex items-center justify-center h-full text-gray-400">Loading...</div>
      {/if}
    </div>
  </div>
{/if}

<style>
  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  .animate-fade-in {
    animation: fade-in 0.2s ease-out;
  }
</style>
